/* jslint esversion: 6 */
/**
 * Favicon Badge
 *
 * Display a favicon badge on non-live environments to help differentiate tabs.
 *
 * @link http://lab.ejci.net/favico.js/
 *
 * @author Dylan James Wagner
 * @package Carbon
 * @subpackage Scripts
 * @since 3.0.0
 */
const hosts = require('../../../gulpfile.js/config.js').hosts;
const Favico = require('favico.js');

function init() {
	const host    = window.location.host;
	const live    = hosts.live    ? hosts.live    : 'www.example.com';
	const test    = hosts.test    ? hosts.test    : 'test.example.com';
	const dev     = hosts.dev     ? hosts.dev     : 'dev.example.com';
	const release = hosts.release ? hosts.release : 'release.example.com';
	const develop = hosts.develop ? hosts.develop : 'develop.example.com';
	const local   = hosts.local   ? hosts.local   : 'example.lndo.site';
	const xip     = hosts.xip     ? hosts.xip     : 'example.lndo.site.*.*.*.*.xip.io';
	const sync    = hosts.sync    ? hosts.sync    : 'sync-example.lndo.site';

	if (host !== live) {
		const favico = new Favico({
			animation  : 'none',      // slide, fade, pop, popFade, none
			position   : 'down',      // down, left, up, upleft
			type       : 'rectangle', // circle, rectangle
			bgColor    : '#c00',      // #dc0000
			textColor  : '#fff',      // #ffffff
			fontFamily : 'mono',      // serif, sans-serif, mono, Arial, Verdana, ...
			fontStyle  : 'normal',    // normal, italic, oblique, bold, bolder, lighter, 100, 200, 300, 400, 500, 600, 700, 800, 900
		});

		/** replace xip.io IP address */
		// console.log(host + ' before');
		// host.replace('/([0-9]*)\.([0-9]*)\.([0-9]*)\.([0-9]*)\.xip\.io/g', '*.*.*.*.xip.io');
		// console.log(host + ' after');

		switch (host) {
			case test    : favico.badge('T'); break;
			case dev     : favico.badge('D'); break;
			case release : favico.badge('R'); break;
			case develop : favico.badge('I'); break;
			case local   : favico.badge('L'); break;
			case sync    : favico.badge('S'); break;
			case xip     : favico.badge('X'); break;
			default      : favico.badge('!'); break;
		}
	}
}

export {init as default};



// WEBPACK FOOTER //
// /app/wp-content/themes/partnershipforthefuture/source/scripts/theme/carbon-favicon-badge.js